//#region src/services/INotificationService.ts
const NOTIFICATION_SERVICE_IDENT = "org.bloomstack.service.NotificationService";
const RPC_EVENT_NOTIFICATION_CREATED_IDENT = "org.bloomstack.event.notificationCreated";
const RPC_EVENT_NOTIFICATION_UPDATED_IDENT = "org.bloomstack.event.notificationUpdated";
const RPC_EVENT_NOTIFICATION_DELETED_IDENT = "org.bloomstack.event.notificationDeleted";
const RPC_EVENT_NOTIFICATION_CREATED = {
	ident: RPC_EVENT_NOTIFICATION_CREATED_IDENT,
	description: "Event emitted when a notification is created",
	params: [{
		name: "notification",
		type: "object",
		description: "The created notification"
	}]
};
const RPC_EVENT_NOTIFICATION_UPDATED = {
	ident: RPC_EVENT_NOTIFICATION_UPDATED_IDENT,
	description: "Event emitted when a notification is updated",
	params: [{
		name: "notification",
		type: "object",
		description: "The updated notification"
	}]
};
const RPC_EVENT_NOTIFICATION_DELETED = {
	ident: RPC_EVENT_NOTIFICATION_DELETED_IDENT,
	description: "Event emitted when a notification is deleted",
	params: [{
		name: "userId",
		type: "string",
		description: "The user whose notification was deleted"
	}, {
		name: "notificationId",
		type: "string",
		description: "The deleted notification ID"
	}]
};

//#endregion
export { NOTIFICATION_SERVICE_IDENT, RPC_EVENT_NOTIFICATION_CREATED, RPC_EVENT_NOTIFICATION_CREATED_IDENT, RPC_EVENT_NOTIFICATION_DELETED, RPC_EVENT_NOTIFICATION_DELETED_IDENT, RPC_EVENT_NOTIFICATION_UPDATED, RPC_EVENT_NOTIFICATION_UPDATED_IDENT };
//# sourceMappingURL=INotificationService.js.map